meedy.controller('meedy.popupChangePasswordController', ['$rootScope', '$scope', '$state', '$mdDialog', 'meedy.passwordModel', 'meedyConfig',
    function ($rootScope, $scope, $state, $mdDialog, passwordModel, config) {

        function setData() {
            $scope.passwordData = new LoginMeedyVO();

            $scope.authenticationError = false;

            $scope.forms = {
                passwordForm: null
            };

            $scope.passwordIsToWeak = false;
            $scope.differentPasswords = false;

            $scope.errorCode = undefined;
        }

        function setPermissions() {
        }

        function setListeners() {

            $scope.$on(Event.MEEDY.PASSWORD.CHANGE_PASSWORD.SUCCESS, function (event, error) {
                _.remove($rootScope.ignoreError, function(url) {
                    return 'passwords'.indexOf(url) > -1;
                });
                $mdDialog.hide();
            });

            $scope.$on(Event.MEEDY.PASSWORD.CHANGE_PASSWORD.ERROR, function (event, error) {
                $scope.errorCode = error.data.errorCode;
            });
        }

        function setActions() {

            $scope.onChange = function() {
                if($scope.forms.passwordForm && $scope.passwordData.newPassword && $scope.passwordData.password
                    && ($scope.passwordData.newPassword.length > 7 && $scope.passwordData.password.length > 7
                    && $scope.passwordData.newPassword === $scope.passwordData.password)) {

                    var power = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g;

                    var _lowerLetters = /[a-z]+/.test($scope.passwordData.password);
                    var _upperLetters = /[A-Z]+/.test($scope.passwordData.password);
                    var _numbers = /[0-9]+/.test($scope.passwordData.password);
                    var _symbols = _regex.test($scope.passwordData.password);

                    if(_lowerLetters) {
                        power++;
                    }if(_upperLetters) {
                        power++;
                    }if(_numbers) {
                        power++;
                    }if(_symbols) {
                        power++;
                    }

                    if(power < 3) {
                        $scope.passwordIsToWeak = true;
                    } else {
                        $scope.passwordIsToWeak = false;
                    }
                    $scope.differentPasswords = false;
                } else if($scope.passwordData.newPassword !== $scope.passwordData.password) {
                    $scope.differentPasswords = true;
                }
            };

            $scope.changePassword = function() {
                $scope.forms.passwordForm.$setSubmitted();

                var power = 0;
                var _regex = /[$-/:-?{-~!"^_`\[\]]/g;

                var _lowerLetters = /[a-z]+/.test($scope.passwordData.password);
                var _upperLetters = /[A-Z]+/.test($scope.passwordData.password);
                var _numbers = /[0-9]+/.test($scope.passwordData.password);
                var _symbols = _regex.test($scope.passwordData.password);

                if(_lowerLetters) {
                    power++;
                }if(_upperLetters) {
                    power++;
                }if(_numbers) {
                    power++;
                }if(_symbols) {
                    power++;
                }

                if(power < 3) {
                    $scope.passwordIsToWeak = true;
                    return;
                } else {
                    $scope.passwordIsToWeak = false;
                }

                if ($scope.forms.passwordForm.$valid) {
                    $scope.errorCode = undefined;
                    $rootScope.ignoreError.push(config.API_URL + '/passwords');
                    passwordModel.changePassword($scope.passwordData.oldPassword, $scope.passwordData.newPassword);
                }
            };

        }


        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        initialize();
    }
]);